import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Guid } from 'guid-ts';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  clientModel = {
    clientName: '',
    clientLastName: '',
    clientEmail: '',
    clientCellNumber: '',
    amount: 50
  }

  transactionId = Guid.newGuid();

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    const clientName = this.route.snapshot.paramMap.get('clientName');
    const clientLastName = this.route.snapshot.paramMap.get('clientLastName');
    const clientEmail = this.route.snapshot.paramMap.get('clientEmail');

    this.clientModel.clientName = clientName;
    this.clientModel.clientLastName = clientLastName;
    this.clientModel.clientEmail = clientEmail;
  }

}
